module.exports = __webpack_public_path__ + "static/media/SmartPhoneUsers.7262a0b1.svg";